/**
 * 所有后台接口调用
 */
/* eslint-disable */
import { httpGet, httpPost } from "./request.js";
import { URLs } from "../common/constants.js";
import convert from "./convert.js";
import questionCvt from "./questionCvt.js";
import { isArray, isObject, isFormData, preLoadResouce } from "../common/util.js";
import personManageCvt from "./pageServices/personManageCvt.js";
import formManageCvt from "./pageServices/formManageCvt.js";
import clusterPageCvt from "./pageServices/clusterPageCvt.js";
import vuexStore from "@/store";
import { Notification } from 'element-ui';
import dataOverviewCvt from "./pageServices/dataOverviewCvt.js";
import hotSpotAnalysisCvt from "./pageServices/hotSpotAnalysisCvt.js";
import satisfactionCvt from "./pageServices/satisfactionCvt.js";
import materialLibraryCvt from './pageServices/materialLibraryCvt.js';
import wikiPageCvt from './pageServices/wikiPageCvt.js'
import serviceDataCvt from './pageServices/serviceDataCvt'
import likeStatisticCvt from './pageServices/likeStatisticCvt';
import { getBusinessId, getTenantId } from "@/lib/auth";
import { isPubg } from "@/views/zhiji/js/lib/businessCheck.js";
import i18n from "@/i18n";

// 数据缓存，game
let localCaches = {
    gameId: "88888",
    editor: "",
    source: 0,
    isLogined: false,
    initedPromise: null // 初始化接口，其他接口要等到这个接口完成才可以访问
};

export function setGameId(gameId) {
    localCaches.gameId = gameId;
}

export function setEditor(editor) {
    localCaches.editor = editor;
}

export function setInitPromise(promise) {
    return;
    localCaches.initedPromise = promise.then(() => localCaches.isLogined = true);
}

// 不需要更新store状态的请求，vue组件中直接使用，根据请求处理函数名称发送请求
export function requestByServiceName(funcName, requestData) {
    const requestHandlers = {
        queryQuestionByName,
        queryQuesSimpleById,
        getBusinessAndEmailInfo,
        getAllGameList,
        getUserLeaderInfo,
        getBatchImport,
        getFaqImportList,
        getFaqExportList,
        getFaqSyncList,
        downloadImportError,
        getBusinessOwnersInfo,
        getBusinessOwners,
        outerSubmitData,
        outerApplyStatus,
        transferSimilars,
        deleteRecSimilars,
        searchQuestionOne,
        queryQaList,
        queryQuestionList,
        judgeExistAloneNonDefault,
        recSimilarLinkQuestion,
        settingWidgetsColor,
        getRecommendShortbar,
        getAccountDetail,
        saveAccountEdit,
        updateAccountEdit,
        saveGroupEdit,
        updateGroupEdit,
        saveRoleEdit,
        updateRoleEdit,
        queryAskAnswerLog,
        getPermitList,
        getFirstRecomData,
        getResourceListData,
        saveFirstRecomData,
        queryDataTrend,
        queryOverviewData,
        queryLogDetail,
        deleteAllotQuestion,
        saveLinkedQuestion,
        linkedConventional,
        deleteConventional,
        queryHotQuestionData,
        queryHotSceneData,
        getDownloadToken,
        getSortSetInfo,
        queryRobotOverviewData,
        queryRobotDataTrend,
        querySatisfySceneData,
        queryQuesSatisfyData,
        getSatisfySetInfo,
        multiUploadImage,
        multiSaveVlinkImage,
        addSinglePicture,
        updateOnePicture,
        deletePicture,
        addOneVLinkVideo,
        updateVLinkVideo,
        deleteVLinkVideo,
        getVlinkGuidesList,
        addVLinkGuides,
        updateVLinkGuides,
        uploadImage,
        queryVLinkVideo,
        getAllChannelData,
        queryMultiLanguage,
        saveMultiLanguageEdit,
        setRecommend,
        removeRecommend,
        queryExportTotal,
        addPermit,
        deletePermit,
        queryResourceList,
        addResource,
        updateResource,
        deleteResource,
        moveResource,
        querySectionList,
        addSection,
        updateSection,
        deleteSection,
        batchSaveResource,
        getBubbleSetting,
        updateBubbleSetting,
        getHotSearch,
        updateHotSearch,
        queryExistedUsers,
        getRelatedQuestion,
        queryCumulativeData,
        queryTiketIndicator,
        queryTiketTrend,
        queryTiketDetail,
        getComponentType,
        getTypeListApi,
        byDownRobotExport,
        getRobotExportList,
        getTreesData,
        transferImg,
        transferTip,
        transferVideo,
        bySceneExportFaq,
        syncFaqToTest,
        queryInfo,
    };
    return requestHandlers[funcName](requestData);
}

// 获取单个业务攻略内容格式
function queryInfo() {
    return queryAndConvertResp("/xiaoyue-operation/business/getRobotsInfo", {}, function(result) {
        return result;
    });
}

// 图片组件-上传图片
function uploadImage(reqData) {
    return postAndConvertResp(URLs.UPLOAD_IMAGE, reqData, function(result) {
        return result;
    });
}

// 提交业务并发送邮件
function getBusinessAndEmailInfo(resData) {
    let request = {
        game_id: resData.gameId,
        game_name: resData.gameName,
        ch_name: resData.chName,
        forecast_online_time: resData.onlineTime,
        users_name: resData.leaderName,
        users: resData.leaderEngName
    };
    return queryAndConvertResp(URLs.SUBMIT_BUSINESS_AND_EMAIL, request, convert.transBusinessAndEmailInfo);
}

// 获取心悦所有游戏列表
function getAllGameList() {
    let request = {
        page: 1,
        page_size: 2000
    };
    return queryAndConvertResp(URLs.GET_ALL_GAME_LIST, request, convert.transAllGameList);
}

// 当前用户已申请的业务
export function getBusinessOwners() {
    let request = {};
    return queryAndConvertResp(URLs.GET_BUSINESS_OWNERS, request, convert.transBusinessOwners);
}

// 获取业务负责人联想数据
function getBusinessOwnersInfo(cb) {
    return preLoadResouce(URLs.BUSINESS_OWNERS_INFO_GET, cb);
}

// 获取当前用户OA信息
export function getUserOaInfo() {
    return queryAndConvertResp(URLs.USER_OA_INFO, {}, convert.tranUserInfo);
}

// 获取直属领导的信息
function getUserLeaderInfo(sid) {
    let request = {
        sid: sid
    };
    return queryAndConvertResp(URLs.USER_LEADER_INFO_GET, request, convert.transUserLeaderInfo);
}

// 请求左侧菜单
export function getLeftMenu() {
    let request = {};

    return queryAndConvertResp(URLs.LEFT_MENU_GET, request, convert.transLeftMenu);
}
// 请求trees数据
export function getTreesData() {
    let request = {
        source: localCaches.source
    };
    return queryAndConvertResp(URLs.TREES_LIST, request, convert.transTreesData);
}

// 图片转移分类
export function transferImg(params) {
    return postAndConvertResp('/xiaoyue-operation/resource/image/shift', params, () => "success");
}

// 攻略转移分类
export function transferTip(params) {
    return postAndConvertResp('/xiaoyue-operation/resource/tip/shift', params, () => "success");
}

// 视频转移分类
export function transferVideo(params) {
    return postAndConvertResp('/xiaoyue-operation/resource/video/shift', params, () => "success");
}

//添加场景请求
export function addQuestionTrees(reqData) {
    let request = {
        parent_set_id: reqData.classId ? reqData.classId : 0,
        set_name: reqData.label,
        source: localCaches.source,
        set_level: reqData.setLevel,
        is_like_display: reqData.isLikeDisplay,
        is_considered: reqData.isConsidered,
    };

    return postAndConvertResp(URLs.TREES_ADD, request, function() {
        return "success";
    });
}

// 更新场景数据请求
export function updateQuestionTrees(reqData) {
    let request = {
        set_id: reqData.id,
        set_name: reqData.label,
        source: localCaches.source,
        status: 1,
        is_like_display: reqData.isLikeDisplay,
        is_considered: reqData.isConsidered,
    };

    return postAndConvertResp(URLs.TREES_UPDATE, request, function() {
        return "success";
    });
}

// 删除场景节点请求
export function deleteQuestionTrees(reqData) {
    let request = {
        set_id: reqData.id,
        source: localCaches.source,
        status: 0
    };

    return postAndConvertResp(URLs.TREES_DELETE, request, function() {
        return "success";
    });
}

// 移动场景列表请求
export function moveQuestionTrees(reqData) {
    let request = {
        set_id: reqData.classId,
        order: reqData.order
    };

    return postAndConvertResp(URLs.MOVE_QUESTION_TREES, request, function(result) {
        return result;
    });
}

function getQuestionListParams(reqData) {
    const statusObj = { delete: 0, online: 1, offline: 2, draft: 3 };
    const questionObj = {
        stand: "question_keyword",
        extend: "ext_question_keyword",
        answer: "answer_keyword",
        questionId: "question_id",
        frameId: "shortcut_bar_question_id",
        formId: "form_id",
        questionIdReverse: "question_id_reverse",
        userProfileParam : "user_profile_param", // 通过用户画像参数模糊查询
        userProfileTag : "user_profile_tag", // 通过用户画像标签模糊查询
        answerId: "answer_id"
    };
    const recommendObj = { recommend: 0, noRecommend: 1, similar: 2, noSimilar: 3 };

    return {
        set_id: reqData.classId,
        audit_status: 1,
        page: reqData.page,
        size: reqData.size,
        status: statusObj[reqData.status] != null ? statusObj[reqData.status] : "",
        type: questionObj[reqData.type] != null ? questionObj[reqData.type] : "",
        field: reqData.field,
        creator: reqData.creator == "all" ? "" : reqData.creator,
        lang: reqData.lang == "all" ? "" : reqData.lang,
        recommend_question: recommendObj[reqData.recommendSimilar] != null ? recommendObj[reqData.recommendSimilar] : "",
        is_contain_lang: reqData.langType || "",
        contain_lang: reqData.smallLang || "",
        component: reqData.components === 'all' || !reqData.components ? '' : reqData.components,
        is_custom_component: reqData.isCustomComponent ? reqData.isCustomComponent : ''
    };
}

// 白板接口-相似问法数量为1
export function searchQuestionOne({ question = '', lang = '' } = {}) {
    const request = { question, lang };
  
    return queryAndConvertResp(URLs.SEARCH_SIMILAR_QUESTION_ONE, request, convert.transQuestionList);
  }

// 线上qa问答提问结果
export async function queryQaList({ request: [{ question = '', lang = '', channel = '' } = {}] = [] } = {}) {
    if (!question) {
      return {};
    }
    const request = {
      audit_status: 1,
      question,
      lang,
      channel,
    };
    return queryAndConvertResp(URLs.SEARCH_QUESTION_BY_AC, request, convert.transMatchRateQues);
  }

// 请求问题列表数据
export function queryQuestionList(reqData) {
    let request = getQuestionListParams(reqData);
    return queryAndConvertResp(URLs.QUESTION_LIST_GET, request, convert.transQuestionList);
}

// 获取FAQ列表相似问法总数接口
export function queryExtQuestionTotal(reqData) {
    let request = getQuestionListParams(reqData);
    return queryAndConvertResp(URLs.EXT_QUESTION_TOTAL_GET, request, function(result) {
        return result.ext_quest_total;
    });
}

// 获取FAQ列表答案总数接口
export function queryAnswersTotal(reqData) {
    let request = getQuestionListParams(reqData);
    return queryAndConvertResp(URLs.ANSWER_TOTAL_GET, request, function(result) {
        return result.answer_total;
    });
}

// 查询推荐相似问法
export function searchRecSimilars(reqData) {
    let request = {
        question_id: reqData.questionId,
        field: "",
        page: reqData.page || "1",
        size: reqData.size || "10"
    };

    return queryAndConvertResp(URLs.SEARCH_RECOMMEND_SIMILAR, request, convert.transRecSimilarSearch);
}
// 删除推荐相似问法
function deleteRecSimilars(reqData) {
    let request = {
        recomment_question_ids: reqData.recSimilarIds.join(",")
    };

    return postAndConvertResp(URLs.DELETE_RECOMMEND_SIMILAR, request, function(result) {
        return result;
    });
}

// 推荐相似问法批量关联标准问法
function recSimilarLinkQuestion(reqData) {
    let request = {
        recomment_question_ids: JSON.stringify(reqData.recSimilarIds),
        ext_question_array: JSON.stringify(reqData.recSimilars),
        question_id: reqData.questionId
    };

    return postAndConvertResp(URLs.SAVE_CLUSTER_QUESTION, request, function(result) {
        return result;
    });
}

// 相似问法转移
function transferSimilars(reqData) {
    let request = {
        ext_question_id_arr: JSON.stringify(reqData.similarIds),
        question_id: reqData.questionId,
        old_question_id: reqData.oldQuestionId,
    };

    return postAndConvertResp(URLs.TRANSFRE_SIMILAR_QUES, request, function(result) {
        return result;
    });
}

// 请求批量导入
function getBatchImport(fileData) {
    fileData.append("game_id", localCaches.gameId);
    fileData.append("editor", localCaches.editor);
    fileData.append("platform_type", "new");

    return postAndConvertResp(URLs.BATCH_IMPORT_UPLOAD, fileData, convert.transBatchImportData, null);
}

// 根据场景导出FAQ
export async function bySceneExportFaq(reqData) {
      const request = getExportFaqParams(reqData)
      return postAndConvertResp(URLs.FQA_EXPORT_BY_SCENEID,request,function(result) {
        return result;
    })
  }

function getExportFaqParams (reqData) {
    const statusObj = {
      delete: 0, online: 1, offline: 2, draft: 3,
    };
    const questionObj = {
        stand: "question_keyword",
        extend: "ext_question_keyword",
        answer: "answer_keyword",
        questionId: "question_id",
        formId: "form_id",
        questionIdReverse: "question_id_reverse",
        userProfileParam : "user_profile_param", // 通过用户画像参数模糊查询
        userProfileTag : "user_profile_tag", // 通过用户画像标签模糊查询
        answerId: "answer_id"
    };
    const recommendObj = {
      recommend: 0, noRecommend: 1, similar: 2, noSimilar: 3,
    };
  
    const request = {
        set_id: reqData.classId,
        audit_status: 1,
        page: reqData.page,
        size: reqData.size,
        status: statusObj[reqData.status] != null ? statusObj[reqData.status] : "",
        type: questionObj[reqData.type] != null ? questionObj[reqData.type] : "",
        field: reqData.field,
        creator: reqData.creator == "all" ? "" : reqData.creator,
        lang: reqData.lang == "all" ? "" : reqData.lang,
        recommend_question: recommendObj[reqData.recommendSimilar] != null ? recommendObj[reqData.recommendSimilar] : "",
        is_contain_lang: reqData.langType || "",
        contain_lang: reqData.smallLang || "",
        component: reqData.components === 'all' || !reqData.components ? '' : reqData.components,
        is_custom_component: reqData.isCustomComponent ? reqData.isCustomComponent : '',
        is_filter: reqData.isFilter || 0
      };
    return request
  }

// 获取FAQ异步导入任务列表
export async function getFaqImportList (reqData) {
    let request = {
        task_id: reqData.taskId || '',
        page: reqData.page || 1,
        size: reqData.size || 10,
    }
    return queryAndConvertResp(URLs.BATCH_IMPORT_HISTORY,request,function(result) {
        return result;
    })
  }
  // 获取FAQ异步导出任务列表
export async function getFaqExportList (reqData) {
    let request = {
        page: reqData.page || 1,
        size: reqData.size || 10,
    }
    return queryAndConvertResp(URLs.BATCH_EXPORT_HISTORY,request,function(result) {
        return result;
    })
}
// 同步FAQ到测试环境
export async function syncFaqToTest (reqData) {
    let request = {
        set_id: reqData.setId || 0,
    }
    return postAndConvertResp(URLs.FAQ_SYNC_TO_TEST, request, function(result) {
        return result;
    })
}
// 获取FAQ同步任务列表
export async function getFaqSyncList (reqData) {
    let request = {
        page: reqData.page || 1,
        size: reqData.size || 10,
    }
    if (reqData.taskId) {
        request.task_id = reqData.taskId;
    }
    return queryAndConvertResp(URLs.FAQ_SYNC_LIST, request, function(result) {
        return result;
    })
}
// 导入错误信息表格下载
export async function downloadImportError (url) {
    let request = {
        path: `${url}&game_id=${localCaches.gameId}&business_id=${getBusinessId()}&tenant_id=${getTenantId()}`
    }
    return queryAndConvertResp(URLs.GET_IMPORT_EERORINFO_TOKEN, request, function(result) {
        return result.redirect;
    });
}

// 请求问题创建人列表数据
export function queryQuesCreators() {
    let request = {};

    return queryAndConvertResp(URLs.QUES_CREATOR_GET, request, convert.transQuesCreator);
}

// 问题上线下线删除状态更新
export function questionStatusUpdate(reqData) {
    const statusObj = { delete: 0, online: 1, offline: 2 };

    let request = {
        question_id: isArray(reqData.questionId) ? reqData.questionId.join(",") : reqData.questionId,
        status: statusObj[reqData.status] != null ? statusObj[reqData.status] : "",
        question: reqData.question || ""
    };

    return postAndConvertResp(URLs.ONLINE_OFF_UPDATE, request, function() {
        return "success";
    });
}

// 问题锁定、解锁状态更新
export function questionLockingStatusUpdate ({ question, questionId, reason, status }) {
    let request = {
      question_id: questionId,
      question,
      reason,
      status,
    };
    return postAndConvertResp(URLs.QUESTION_LOCKING_STATUS_UPDATE, request, function(result) {
        return result;
    });
}

// 设置为首问状态更新
export function setFirstQuestion(reqData) {
    let request = {
        default_question_id: reqData.questionId
    };

    return postAndConvertResp(URLs.SET_FIRST_DEFAULT, request, function(result) {
        return result;
    });
}

// 设置为兜底
export function setRevealQuestion(reqData) {
    let request = {
        question_id: reqData.questionId
    };

    return postAndConvertResp(URLs.SET_REVEAL, request, function(result) {
        return result;
    });
}

// 转移问题的分类目录
export function transferQuesClass(reqData) {
    let request = {
        game_id: localCaches.gameId,
        question_ids: reqData.questionIds.join(','),
        set_id: reqData.classId,
    };
   // request = appendCommon2QueryStr(request);
    return postAndConvertResp(URLs.TRANSFER_QUES_UPDATE, request, function() {
        return "success";
    });
}

// 转移前先判断有无单独非默认语种标问
export function judgeExistAloneNonDefault(reqData) {
    const request = {
        question_ids: reqData.questionIds
    }
    return queryAndConvertResp(URLs.TRANSFER_IS_EXIST_ALONG_MIN_LANG, request, result => result)
}

// 获取问题详情
export function queryQuestionDetail(reqData) {
    let request = {
        set_id: reqData.sceneId || "",
        question_id: reqData.questionId
    };

    return queryAndConvertResp(URLs.QUES_DETAIL_GET, request, convert.transQuesDetail);
}

// 单独获取相似问法详情
export function searchSimilarsList(reqData) {
    let request = {
        question_id: reqData.questionId,
        ext_question: reqData.extQuestion || "",
        page: reqData.pageNo || 1,
        size: reqData.pageSize || 20
    };

    return queryAndConvertResp(URLs.SIMILLAR_LIST_GET, request, convert.transSimilarDetail);
}

// 新增相似问法
export function addSimilar(reqData) {
    let request = {
        question_id: reqData.questionId,
        ext_question_array: JSON.stringify(reqData.similarArr)
    };

    return postAndConvertResp(URLs.ADD_SIMILAR, request, function(result) {
        return result.question_id;
    });
}

// 更新相似问法
export function updateSimilar(reqData) {
    let request = {
        ext_question: reqData.extQuestion,
        ext_question_id: reqData.extQuestionId,
        question_id: reqData.questionId,
    };

    return postAndConvertResp(URLs.UPDATE_SIMILAR, request, function(result) {
        return result.ext_question_id;
    });
}

// 删除相似问法
export function deleteSimilar(reqData) {
    let request = {
        ext_question_ids: reqData.deleteSimilarIds.join(","),
        question_id: reqData.questionId,
    };

    return postAndConvertResp(URLs.DELETE_SIMILAR, request, function(result) {
        return result;
    });
}

// 获取指定语种的首问
export async function getFirstQuestion(request) {
    beforeSend(request);
    const res = await httpGet("/xiaoyue-operation/getFirstQuestion", request);
    return res;
}

// 问题编辑保存
export function questionEidtSave(reqData) {
    let request = questionCvt.cvt2ServerParam(reqData);
    let url = reqData.questionInfo.questionId ? URLs.QUES_EDIT_UPDATE : URLs.QUES_EDIT_SAVE;

    return postAndConvertResp(url, request, function(result) {
        return result.question_id;
    });
}

// 根据名称模糊搜索问题接口
export function queryQuestionByName(reqData) {
    let request = {
        page: reqData.pageIdx,
        size: reqData.pageSize,
        field: reqData.searchText
    };

    return queryAndConvertResp(URLs.QUES_LIST_BY_NAME, request, convert.transQuesSimpleList);
}

// 根据问题Id获取问题文本内容接口
export function queryQuesSimpleById(reqData) {
    let request = {
        question_id: reqData.questionId
    };

    return queryAndConvertResp(URLs.QUES_ANSWER_TEXT_GET, request, convert.transQuesSimpleText);
}

// 外部人员提交申请接入
function outerSubmitData(reqData) {
    let request = {
        mobile: reqData.mobile,
        email: reqData.email,
        nickname: reqData.nickName,
        forecast_online_time: reqData.onlineTime,
        ch_name: reqData.chName,
        game_name: reqData.gameName
    };

    return postAndConvertResp(URLs.OUTER_SUBMIT_APPLY_DATA, request, convert.transOuterSubmitData);
}

// 查询外部人员申请状态
export function outerApplyStatus() {
    let request = {};
    return queryAndConvertResp(URLs.GET_OUTER_APPLY_STATUS, request, convert.transOuterApplyStatus);
}

// 外部-退出登陆
export function outerLogout() {
    let request = {};
    return queryAndConvertResp(URLs.OUTER_LOGOUT, request, convert.transOuterLogout);
}

// 搜索推荐问法
export function searchReferenceSimilars(reqData) {
    let request = {
        query: reqData.keywords
    };

    return postAndConvertResp(URLs.SEARCH_REC_SIMILARS, request, function(result) {
        return result;
    });
}

// 发送get请求，并对没有gameId的情况进行并行处理
export function queryAndConvertResp(url, params, succConvert, errConvert) {
    if (!localCaches.isLogined && localCaches.initedPromise) {
        return localCaches.initedPromise.then(function() {
            return getAndConvertResp(url, params, succConvert, errConvert);
        });
    } else {
        return getAndConvertResp(url, params, succConvert, errConvert);
    }
}

// 发送请求，并且对返回进行处理
export function getAndConvertResp(url, params, succConvert, errConvert) {
    beforeSend(params);

    return httpGet(url, params)
        .then(result => {
            return succConvert(result);
        })
        .catch(err => {
            console.log(err);
            if (!errConvert) {
                defaultErrorManager(err);
                throw err;
            }
            return errConvert(err);
        });
}

// 发送请求，并且对返回进行处理
export function postAndConvertResp(url, params, succConvert, errConvert) {
    beforeSend(params);

    return httpPost(url, params)
        .then(result => {
            return succConvert(result);
        })
        .catch(err => {
            console.log(err);
            if (!errConvert) {
                defaultErrorManager(err);
                throw err;
            }
            return errConvert(err);
        });
}

// 请求组件类型
export function getComponentType () {
    return queryAndConvertResp(URLs.GET_COMPONENTS_LIST, {}, result => result);
}

// 默认错误处理
function defaultErrorManager(err) {
    if (err && err.response && err.response.data) {
        Notification.closeAll(); // 去除框架的提示弹框
        vuexStore.dispatch("zhiji/showModal", {
            type: "MessageModal",
            data: {
                type: "error",
                message: err.response.data.err_msg
            }
        });
    }
}

// 请求发送前统一处理
export function beforeSend(params) {
    if (isObject(params) && !isFormData(params)) {
        params.game_id || (params.game_id = localCaches.gameId);
    }
}

// 添加统一参数并转换成paramstr
function appendCommon2QueryStr(params) {
    beforeSend(params);

    return data2ParamString(params);
}

// param对象转换为paramStr
function data2ParamString(data) {
    if (typeof data === "string") {
        return data;
    }
    return objectToParamString(data);
}

// 将对象转换成键值对形式，只支持单层
function objectToParamString(data) {
    var ret = "";
    for (var key in data) {
        ret = ret + key + "=" + encodeURIComponent(data[key]) + "&";
    }
    ret = ret.substr(0, ret.length - 1); // 去除最后的'&'
    return ret;
}

// 获取答案属性数据
export function queryAnswerProps() {
    let request = {};
    if (isPubg()) {
        return queryAndConvertResp(URLs.GET_ANSWER_PROPS, request, convert.transAnswerPropData);
    }
    return queryAndConvertResp(URLs.GET_ANSWER_PROPS_V2, request, convert.transAnswerPropData);
}

// 保存组件颜色配置
function settingWidgetsColor(reqData) {
    let param = `{
            "module": {
                "text": {
                    "color": {
                        "bubble": "${reqData.colorData.bubble}",
                        "text": "${reqData.colorData.text}",
                        "link": "${reqData.colorData.outerLink}",
                        "routing": "${reqData.colorData.innerLink}",
                        "question": "${reqData.colorData.question}",
                        "highlight": "${reqData.colorData.highlight}"
                    }
                }
            }
        }`;
    let request = {
        setting: param.replace(/\s+/g, "")
    };

    return postAndConvertResp(URLs.SETTING_WIDGETS_COLOR, request, function(result) {
        return result;
    });
}

// 获取推荐的快捷栏
export function getRecommendShortbar(reqData) {
    let request = {
        set_id: reqData.sceneId,
        filter_qid: reqData.questionId,
        lang: reqData.lang
    };
    return queryAndConvertResp(URLs.GET_RECOMMEND_SHORTBAR, request, convert.transRecommendShortbar);
}

// 人员管理：账号管理列表
export function queryAccountData(reqData) {
    let request = personManageCvt.cvtAccountParam(reqData);
    return queryAndConvertResp(URLs.ACCOUNT_LIST_GET, request, convert.transAccountList);
}

// 人员管理：账号详情
function getAccountDetail(reqData) {
    let request = personManageCvt.cvtAccountParam(reqData);
    return queryAndConvertResp(URLs.ACCOUNT_LIST_GET, request, convert.transAccountList);
}

// 人员管理：账号新增保存
function saveAccountEdit(reqData) {
    let request = personManageCvt.cvtAccountSaveParam(reqData);

    return postAndConvertResp(URLs.ACCOUNT_EDIT_SAVE, request, function(result) {
        return result;
    }, (err) => {
        const resp = err.response.data;
        return { errCode: resp.err_code, errMsg: resp.err_msg }
    });
}

// 人员管理：账号更新保存
function updateAccountEdit(reqData) {
    let request = personManageCvt.cvtAccountUpdateParam(reqData);

    return postAndConvertResp(URLs.ACCOUNT_EDIT_UPDATE, request, function(result) {
        return result;
    });
}

// 人员管理：账号删除
export function deleteAccountData(reqData) {
    let request = {
        member_id: reqData.accountId,
    };

    return postAndConvertResp(URLs.ACCOUNT_DATA_DELTE, request, function(result) {
        return result;
    });
}

// 人员管理：账号状态更新 停用、启用
export function updateAccountStatus(reqData) {
    let request = {
        member_id: reqData.accountId,
        status: reqData.status,
    };

    return postAndConvertResp(URLs.ACCOUNT_STATUS_UPDATE, request, function(result) {
        return result;
    });
}

// 请求所有组别信息
export function queryGroupOptions() {
    let request = {};
    return queryAndConvertResp(URLs.GROUP_OPTIONS_GET, request, convert.transGroupOption);
}

// 人员管理：分组管理列表
export function queryGroupData(reqData) {
    let request = personManageCvt.cvtGroupParam(reqData);
    return queryAndConvertResp(URLs.GROUP_LIST_GET, request, convert.transGroupList);
}

// 人员管理：组别删除
export function deleteGroupData(reqData) {
    let request = {
        group_id: reqData.groupId,
    };

    return postAndConvertResp(URLs.GROUP_DATA_DELTE, request, function(result) {
        return result;
    });
}

// 人员管理：组别新增保存
function saveGroupEdit(reqData) {
    let request = personManageCvt.cvtGroupSaveParam(reqData);

    return postAndConvertResp(URLs.GROUP_EDIT_SAVE, request, function(result) {
        return result;
    });
}

// 人员管理：组别更新保存
function updateGroupEdit(reqData) {
    let request = personManageCvt.cvtGroupUpdateParam(reqData);

    return postAndConvertResp(URLs.GROUP_EDIT_UPDATE, request, function(result) {
        return result;
    });
}

// 人员管理：组别状态更改：停用，启用
export function updateGroupStatus(reqData) {
    let request = {
        group_id: reqData.groupId,
        status: reqData.status,
    };

    return postAndConvertResp(URLs.GROUP_STATUS_UPDATE, request, function(result) {
        return result;
    });
}

// 人员管理：角色管理列表
export function queryRoleData(reqData) {
    let request = personManageCvt.cvtRoleListParam(reqData);
    return queryAndConvertResp(URLs.ROLE_LIST_GET, request, convert.transRoleList);
}

// 请求所有角色信息
export function queryRoleOptions() {
    let request = {};
    return queryAndConvertResp(URLs.ROLE_OPTIONS_GET, request, convert.transRoleOption);
}

// 人员管理：角色删除
export function deleteRoleData(reqData) {
    let request = {
        role_id: reqData.roleId,
    };

    return postAndConvertResp(URLs.ROLE_DATA_DELTE, request, function(result) {
        return result;
    });
}

// 人员管理：角色状态更改：停用，启用
export function updateRoleStatus(reqData) {
    let request = {
        role_id: reqData.roleId,
        status: reqData.status,
    };

    return postAndConvertResp(URLs.ROLE_STATUS_UPDATE, request, function(result) {
        return result;
    });
}

// 角色管理：获取权限列表
function getPermitList(reqData = {}) {
    let request = {
        filter_business_id: reqData.bId,
    };
    return queryAndConvertResp(URLs.PERMIT_LIST_GET, request, convert.transPermitList);
}

// 人员管理：角色新增保存
function saveRoleEdit(reqData) {
    let request = personManageCvt.cvtRoleSaveParam(reqData);

    return postAndConvertResp(URLs.ROLE_EDIT_SAVE, request, function(result) {
        return result;
    });
}

// 人员管理：角色更新保存
function updateRoleEdit(reqData) {
    let request = personManageCvt.cvtRoleUpdateParam(reqData);

    return postAndConvertResp(URLs.ROLE_EDIT_UPDATE, request, function(result) {
        return result;
    });
}

// 人员管理：搜索角色名称
function queryExistedUsers(request) {
    return getAndConvertResp(URLs.SEARCH_USERS, request, function(result) {
        return result;
    });
}

// 请求标签管理trees数据
export function getTagTreesData() {
    return queryAndConvertResp(URLs.TAG_TREES_SEARCH, {}, formManageCvt.transTagTreesData);
}

// 保存标签管理trees
export function saveTagTreesData(reqData) {
    let request = formManageCvt.cvtSaveTreesParam(reqData);

    return postAndConvertResp(URLs.SAVE_ZHIJI_TAG_TREES, request, function() {
        return "success";
    });
}

// 移动标签管理trees
export function moveTagTreesData(reqData) {
    let request = formManageCvt.cvtMoveTreesParam(reqData);

    return postAndConvertResp(URLs.MOVE_ZHIJI_TAG_TREES, request, function() {
        return "success";
    });
}

// 删除标签管理trees
export function deleteTagTreesData(reqData) {
    let request = formManageCvt.cvtDeleteTreesParam(reqData);

    return postAndConvertResp(URLs.DELETE_ZHIJI_TAG_TREES, request, function() {
        return "success";
    });
}

// 更新标签管理trees
export function updateTagTreesData(reqData) {
    let request = formManageCvt.cvtUpdateTreesParam(reqData);

    return postAndConvertResp(URLs.UPDATE_ZHIJI_TAG_TREES, request, function() {
        return "success";
    });
}

// 请求获取表单列表
export function queryFormList(reqData) {
    let request = formManageCvt.cvtFormListParam(reqData);
    return queryAndConvertResp(URLs.GET_FORM_LIST, request, formManageCvt.transFormListData);
}

// 创建表单
export function createForms(reqData) {
    let request = formManageCvt.cvtCreateFormParam(reqData);

    return postAndConvertResp(URLs.CREATE_ZHIJI_FORMS, request, function() {
        return "success";
    });
}

// 修改表单
export function updateForms(reqData) {
    let request = formManageCvt.cvtUpdateFormParam(reqData);

    return postAndConvertResp(URLs.UPDATE_ZHIJI_FORMS, request, function() {
        return "success";
    });
}

// 修改表单状态
export function updateFormStatus(reqData) {
    let request = formManageCvt.cvtUpdateFormStatusParam(reqData);

    return postAndConvertResp(URLs.UPDATE_ZHIJI_FORM_STATUS, request, function(result) {
        return result;
    });
}

// 删除表单
export function deleteForms(reqData) {
    let request = formManageCvt.cvtDeleteFormParam(reqData);

    return postAndConvertResp(URLs.DELETE_ZHIJI_FORMS, request, function(result) {
        return result;
    });
}

// 复制表单
export function copyForms(reqData) {
    let request = formManageCvt.cvtCopyFormParam(reqData);

    return postAndConvertResp(URLs.COPY_ZHIJI_FORMS, request, function() {
        return "success";
    });
}

// 设置为默认表单
export function setDefaultForm(reqData) {
    let request = formManageCvt.cvtDefaultForm(reqData);

    return postAndConvertResp(URLs.SET_DEFAULT_ZHIJI_FORMS, request, function() {
        return "success";
    });
}

// 取消设置为默认表单
export function cancelDefaultForm(reqData) {
    let request = formManageCvt.cvtDefaultForm(reqData);

    return postAndConvertResp(URLs.CANCEL_DEFAULT_ZHIJI_FORMS, request, function() {
        return "success";
    });
}

// 是否设置了默认表单
export function isSetDefaultForm(reqData) {
    let request = {
        lang: reqData.lang,
    };

    return queryAndConvertResp(URLs.IS_Exist_DEFAULT_ZHIJI_FORMS, request, function(result) {
        return result;
    });
}

// 获取问答日志列表数据
function queryAskAnswerLog(reqData) {
    const searchObj = { "all": "", "user": "user_id", "scenes": "set_id", "content": "question", "standard": "match_question" , "questionId": "question_id", "chatId": "session_id" };
    const wordsObj = { "all": "", "yes": "1", "no": "0" };
    const questionObj = { "all": "", "initQues": "first_ask", "input": "input", "click": "click" }
    const logTypeObj = { "likeLog": "like_log", "qaLog": "qa_log" };
    let request = {
        start_time: reqData.startDate,
        end_time: reqData.endDate,
        page: reqData.curPage,
        size: reqData.size,
        channel: reqData.channel || "",
        question_type: questionObj[reqData.questionType] || "",
        answer_type: reqData.answerType || "",
        search_type: searchObj[reqData.searchType],
        keyword: reqData.keyWord || "",
        user_id: reqData.userId || "",
        order_column: reqData.order || "desc",
        language: reqData.lang || "",
        sensitive_words: wordsObj[reqData.senWords] || "",
        log_type: logTypeObj[reqData.logType] || "",
        click_id: reqData.clickId,
        index_score_min: reqData.indexScoreMin || "",
        index_score_max: reqData.indexScoreMax || "",
        translate_lang: i18n.locale == "cn" ? "zh" : "en"
    }
    return queryAndConvertResp(URLs.GET_ASK_ANSWER_LOG, request, convert.transAskAnswerLog);
}

// 获取表单详情
export function queryFormDetail(reqData) {
    let request = formManageCvt.cvtFormDetailParam(reqData);
    return queryAndConvertResp(URLs.GET_ZHIJI_FORM_DETAIL, request, formManageCvt.transFormDetailData);
}

// 根据questionId获取同语义所有questions状态
export function querySynonymQuestions(reqData) {
    return queryAndConvertResp(URLs.GET_SYNONYM_QUESTIONS, { question_id: reqData.questionId }, convert.transSynonymQuestions);
}

// 首屏推荐查询
function getFirstRecomData(reqData) {
    let request = {
        classify: "hotQuestionList",
        code: "hotQuestionList",
        lang: reqData.lang,
        channel: reqData.channel,
        status: reqData.status || ""
    };
    return queryAndConvertResp(URLs.GET_FIRST_RECOMMEND, request, convert.transFirstRecom);
}

// 内容助手：首屏推荐内容查询
function getResourceListData(reqData) {
    let request = {
        classify: "recommendResourceList",
        code: "recommendResourceList",
        lang: reqData.lang,
        channel: reqData.channel,
        status: reqData.status || ""
    };
    return queryAndConvertResp(URLs.GET_FIRST_RECOMMEND, request, convert.transRecomResource);
}

// 首屏推荐保存
function saveFirstRecomData(reqData) {
    const statusObj = { online: 1, offline: 2, draft: 3 };
    let request = {
        classify: reqData.type,
        code: reqData.type,
        content: JSON.stringify(reqData.content),
        lang: reqData.lang,
        status: statusObj[reqData.status],
        channel: reqData.channel
    };
    let url = reqData.id ? URLs.UPDATE_FIRST_RECOMMEND : URLs.ADD_FIRST_RECOMMEND;

    return postAndConvertResp(url, request, function(result) {
        return result;
    });
}

// 获取数据趋势
function queryDataTrend(reqData) {
    let type = {
        "trend": "chartData",
        "robot": "robotData",
        "labour": "labourData"
    };

    let cvtType = type[reqData.type];

    let request = dataOverviewCvt.cvtDataTrendParam(reqData);
    return queryAndConvertResp(URLs.GET_DATA_TREND, request, dataOverviewCvt.transDataTrend()[cvtType]);
}

// 机器人监控：数据趋势
function queryRobotDataTrend(reqData) {
    let request = {
        language: reqData.lang && reqData.lang != "all" ? reqData.lang : "",
        channel: reqData.channel && reqData.channel != "all" ? reqData.channel : "",
        date: reqData.endTime
    }
    return queryAndConvertResp(URLs.GET_ROBOT_DATA_TREND, request, dataOverviewCvt.transDataTrend()["robotTrendData"]);
}

function queryOverviewData(reqData) {
    let request = dataOverviewCvt.cvtDataOverviewParam(reqData);
    return queryAndConvertResp(URLs.GET_DATA_OVERVIEW, request, dataOverviewCvt.transDataOverview);
}

function queryRobotOverviewData(reqData) {
    let request = {
        language: reqData.lang && reqData.lang != "all" ? reqData.lang : "",
        channel: reqData.channel && reqData.channel != "all" ? reqData.channel : "",
        date: reqData.startTime
    }
    return queryAndConvertResp(URLs.GET_ROBOT_DATA_OVERVIEW, request, dataOverviewCvt.cvtRobotOverview);
}

// 聚类：查询聚类卡片数量
export function queryCardList(reqData) {
    let request = {
        page: reqData.page,
        size: 6,
        field: reqData.field || "",
        cluster_lang: reqData.lang,
        translate_lang: i18n.locale == "cn" ? "zh" : "en"
    }
    return queryAndConvertResp(URLs.GET_CLUSTER_COUNT, request, convert.transCardsData);
}

// 删除聚类卡片问题
function deleteAllotQuestion(reqData) {
    let request = {
        cluster_id: reqData.clusterId,
        question_ids: JSON.stringify(reqData.questionIds),
        cluster_lang: reqData.lang
    }
    
    return postAndConvertResp(URLs.DELETE_ALLOT_QUESTION, request, function(result) {
        return result;
    });
}

// 保存聚类问题关联标准问法
function saveLinkedQuestion(reqData) {
    let request = {
        ext_question_array: JSON.stringify(reqData.questions),
        cluster_question_ids: JSON.stringify(reqData.questionIds),
        question_id: reqData.linkQuestionId,
        cluster_id: reqData.clusterId,
        cluster_lang: reqData.lang
    }

    return postAndConvertResp(URLs.SAVE_CLUSTER_QUESTION, request, function(result) {
        return result;
    });
}

// 聚类：获取常规闭环数据
export function queryConventionalList(reqData) {
    let request = clusterPageCvt.conventionalListParams(reqData);
    return queryAndConvertResp(URLs.GET_CONVENTION_LIST, request, convert.transConventional);
}

//聚类 常规闭环删除
function deleteConventional(reqData) {
    let request = {
        smart_question_ids: reqData.questionIds
    };
    return postAndConvertResp(URLs.DELETE_CONVENTION, request, function(result) {
        return result;
    });
}

// 常规闭环页面一键翻译
export function translateConventional({ to, list, type }) {
    let request = { to, list, server_type: type };
    return postAndConvertResp(URLs.TRANSLATE_CONVENTION, request, function(result) {
      return result;
    });
}

// 常规闭环页面混元翻译
function getServerDomain() {
    const preServiceHost = "https://pre-api-interopen.gbot.qq.com";
    const onlineServiceHost = "https://open.vlinkapi.com";
    const testServiceHost = "https://test-api-interopen.gbot.qq.com";

    const isPreEnv = window.location.host && window.location.host.indexOf("pre-interopen.") > -1;
    const isTest = window.location.host && window.location.host.indexOf("test-interopen.") > -1;

    return isPreEnv ? preServiceHost : isTest ? testServiceHost : onlineServiceHost;
}
const domain = getServerDomain();


function createTokenWithParams(params){
    let request = {
        ...params,
    };
    return postAndConvertResp(URLs.CREATE_TOKEN, request, function(result) {
        return result;
    });
}

export async function sseRequest({
  apiPath,target, list , onStart, onMessage, onError, onEnd,
}) {
  try {
    const response = await createTokenWithParams({target,list})
    const {token} = response
    // 使用token构建SSE URL
    const baseUrl = `${domain}${apiPath}?token=${token.toString()}`;
    const eventSource = new EventSource(baseUrl, { withCredentials: true });

    eventSource.onopen = () => {
      if (onStart) {
        onStart();
      }
    };

    eventSource.onmessage = (event) => {
      if (onMessage) {
        onMessage(event);
      }
    };

    eventSource.onerror = (event) => {
      if (onError) {
        onError(event);
      }
      eventSource.close();
    };

    eventSource.onclose = () => {
      if (onEnd) {
        onEnd();
      }
    };

    return eventSource;
  } catch (error) {
    if (onError) {
      onError(error);
    }
    throw error;
  }
}

//聚类：常规闭环关联为相似问法
function linkedConventional(reqData) {
    let request = {
        ext_question_array: JSON.stringify(reqData.questions),
        smart_question_ids: JSON.stringify(reqData.questionIds),
        question_id: reqData.linkQuestionId
    };
    return postAndConvertResp(URLs.SAVE_CLUSTER_QUESTION, request, function(result) {
        return result;
    });
}

// 聚类：查看日志详情
function queryLogDetail(reqData) {
    let request = {
        page: reqData.page,
        size: reqData.size,
        status: reqData.status,
        cluster_lang: reqData.lang
    }
    return queryAndConvertResp(URLs.SEARCH_LOG_DETAIL, request, convert.transLogDetailData);
}

// 敏感词分组列表
export function querySensitiveGroupList(reqData) {
    const statusObj = { "online": "1", "offline": "0", "draft": "3" }
    let request = {
        status: statusObj[reqData.status] || "",
        lang: reqData.lang || "",
        classify: reqData.classify || "",
        size: reqData.size,
        page: reqData.page
    };
    return queryAndConvertResp(URLs.GET_SENSITIVE_GROUP_LIST, request, convert.transSensitiveData);
}

// 新增敏感词分类
export function saveSensitiveGroup(reqData) {
    let request = {
        classify: reqData.groupName,
        lang: reqData.lang,
        words: ""
    };
    return postAndConvertResp(URLs.ADD_SENSITIVE_GROUP, request, function(result) {
        return result;
    });
}

// 更新敏感词分类
export function updateSensitiveGroup(reqData) {
    const statusObj = { "online": "1", "offline": "0", "draft": "3" }
    let request = {
        classify: reqData.classify,
        lang: reqData.lang,
        words: cvtWords2Server(reqData.wordsArr),
        id: reqData.id,
        deleted: reqData.deleted,
        status: statusObj[reqData.status]
    };
    return postAndConvertResp(URLs.UPDATE_SENSITIVE_WORDS, request, function(result) {
        return result;
    });
}

// 服务端敏感词  字符串
function cvtWords2Server(wordsArr) {
    let newParam = [];
    newParam = wordsArr.map(item => item.word);
    return newParam.join(",");
}
// 获取热点问题列表数据
function queryHotQuestionData(reqData) {
    let request = hotSpotAnalysisCvt.queryHotQues2Server(reqData);
    return queryAndConvertResp(URLs.GET_HOT_QUESTION, request, hotSpotAnalysisCvt.hotQuesData2Client);
}

function queryHotSceneData(reqData) {
    let request = hotSpotAnalysisCvt.queryHotScene2Server(reqData);
    return queryAndConvertResp(URLs.GET_HOT_SETS, request, hotSpotAnalysisCvt.hotSceneData2Client);
}

function getDownloadToken(url) {
    let request = {
        path: `${url}&game_id=${localCaches.gameId}&business_id=${getBusinessId()}&tenant_id=${getTenantId()}`
    }
    return queryAndConvertResp(URLs.GET_DOWNLOAD_TOKEN, request, function(result) {
        return result.redirect;
    });
}

// 根据场景导出机器人日志
function byDownRobotExport(reqData) {
    const searchObj = { "all": "", "user": "user_id", "scenes": "set_id", "stand": "question", "questionId": "question_id", "chatId": "session_id" };
    const wordsObj = { "all": "", "yes": "1", "no": "0" };
    const questionObj = { "all": "", "initQues": "first_ask", "input": "input", "click": "click" }
    const logTypeObj = { "likeLog": "like_log", "qaLog": "qa_log" };
    const request = {
        start_time: reqData.startDate,
        end_time: reqData.endDate,
        page: reqData.curPage,
        size: reqData.size,
        channel: reqData.channel || "",
        question_type: questionObj[reqData.questionType] || "",
        answer_type: reqData.answerType || "",
        search_type: searchObj[reqData.searchType],
        keyword: reqData.keyWord || "",
        user_id: reqData.userId || "",
        order_column: reqData.order || "desc",
        language: reqData.lang || "",
        sensitive_words: wordsObj[reqData.senWords] || "",
        index_score_min: reqData.indexScoreMin || "",
        index_score_max: reqData.indexScoreMax || "",
        translate_lang: i18n.locale == "cn" ? "zh" : "en",
        log_type: logTypeObj[reqData.logType] || "",
        click_id: reqData.clickId,
    };
    return postAndConvertResp(URLs.CHAT_LOG_EXPORT, request, result => result);
}
// 导出机器人日志列表详情
function getRobotExportList({ page = 1, size = 10, logType }) {
    const logTypeObj = { "likeLog": "like_log", "qaLog": "qa_log" };
    const request = {
        page,
        size,
        log_type: logTypeObj[logType] || "",
    };
    return queryAndConvertResp(URLs.CHAT_LOG_EXPORT_LIST, request, convert.transRobotExportLogData);
}

// 请求问题热点-场景列表
function getSortSetInfo(reqData) {
    let request = Object.assign({}, {
        source: localCaches.source
    }, hotSpotAnalysisCvt.querySortSetInfo2Server(reqData));

    return queryAndConvertResp(URLs.GET_SORT_SET_INFO, request, convert.transTreesData);
}

// 获取场景满意度
function querySatisfySceneData(reqData) {
    let request = satisfactionCvt.querySatisfyScene2Server(reqData);
    return queryAndConvertResp(URLs.GET_SATISFACTION_SENCE, request, satisfactionCvt.satisfySceneData2Client);
}

// 获取问题满意度
function queryQuesSatisfyData(reqData) {
    let request = satisfactionCvt.queryQuesSatisfy2Server(reqData);
    return queryAndConvertResp(URLs.GET_QUES_SATISFACTION, request, satisfactionCvt.satisfyQuesData2Client);
}
// 请求问题满意度-场景列表
function getSatisfySetInfo(reqData) {
    let request = satisfactionCvt.querySortSetInfo2Server(reqData);
    return queryAndConvertResp(URLs.GET_SATISFACTION_SET_INFO, request, convert.transTreesData);
}

// 获取资料库Tag：图片库，视频库，攻略库共用
export function queryTagTreesData(param) {
    let request = {
        field: param.field || "",
        tag_type: param.type
    };
    return queryAndConvertResp(URLs.GET_MATERIAL_TREES_LIST, request, materialLibraryCvt.transTagTreesData);
}

//资料库Tag新增
export function addMaterialTagTrees(reqData) {
    let request = {
        parent_tag_id: reqData.classId ? reqData.classId : 0,
        tag_name: reqData.label,
        tag_level: reqData.setLevel,
        tag_type: reqData.type
    }

    return postAndConvertResp(URLs.ADD_MATERIAL_TAG, request, function(result) {
        return 'success';
    });
}

// 资料库tag更新
export function updateMaterialTagTrees(reqData) {
    let request = {
        tag_id: reqData.id,
        tag_name: reqData.label,
        tag_type: reqData.type,
    }
    // request = appendCommon2QueryStr(request);
    return postAndConvertResp(URLs.UPDATE_MATERIAL_TAG, request, function(result) {
        return 'success';
    });
}

// 资料库tag删除
export function deleteMaterialTagTrees(reqData) {
    let request = {
        tag_id: reqData.id,
        tag_type: reqData.type,
    };

    return postAndConvertResp(URLs.DELETE_MATERIAL_TAG, request, function(result) {
        return 'success';
    });
}

// 资料库tag移动
export function moveMaterialTagTrees(reqData) {
    let request = {
        tag_id: reqData.classId,
        order: reqData.order,
        tag_type: reqData.type,
    }

    return postAndConvertResp(URLs.MOVE_MATERIAL_TAG, request, function(result) {
        return result;
    });
}

// 获取VLink图片库列表
export function queryZhiJiPicture(reqData) {
    let request = materialLibraryCvt.imgList2ServerParam(reqData);

    return queryAndConvertResp(URLs.GET_VLINK_PICTURE_LIST, request, convert.transVLinkPicture);
}

// VLink新增单个图片
function addSinglePicture(reqData) {
    let request = materialLibraryCvt.singleImg2ServerParam(reqData, localCaches);
    //let request = appendCommon2QueryStr(requestParam);
    return postAndConvertResp(URLs.ADD_ONE_PICTURE, request, materialLibraryCvt.cvtPictureItemData);
}

// VLink更新图片
function updateOnePicture(reqData) {
    let request = materialLibraryCvt.updateImg2ServerParam(reqData);

    return postAndConvertResp(URLs.UPDATE_ONE_PICTURE, request, materialLibraryCvt.cvtPictureItemData);
}

// vlink批量上传图片
function multiUploadImage(reqData) {
    return postAndConvertResp(URLs.MULTI_ADD_VLINK_PICTURE, reqData, materialLibraryCvt.cvtMulitImportImg, null);
}

// 批量保存VLink图片
function multiSaveVlinkImage(reqData) {
    let request = {
        images: materialLibraryCvt.multiImg2ServerParam(reqData),
    };

    return postAndConvertResp(URLs.MULTI_SAVE_VLINK_PICTURE, request, function(result) {
        return result;
    });
}

// VLink删除图片
function deletePicture(reqData) {
    let request = {
        image_ids: reqData.pictureIds
    };

    return postAndConvertResp(URLs.DELETE_VLINK_PICTURE, request, function(result) {
        return result;
    });
}

// 获取VLink视频列表数据
export function queryVLinkVideo(reqData) {
    let request = materialLibraryCvt.VLinkVideoList2Server(reqData);
    return queryAndConvertResp(URLs.GET_VLINK_VIDEO_LIST, request, materialLibraryCvt.VLinkVideoList2Client);
}

// VLink视频：新增
function addOneVLinkVideo(reqData) {
    let request = materialLibraryCvt.addVLinkVideo2Server(reqData, localCaches);

    return postAndConvertResp(URLs.ADD_VLINK_VIDEO, request, materialLibraryCvt.vlinkVideo2Client);
}

// VLink视频：更新
function updateVLinkVideo(reqData) {
    let request = materialLibraryCvt.updateVlinkVideo2Server(reqData);

    return postAndConvertResp(URLs.UPDATE_VLINK_VIDEO, request, materialLibraryCvt.vlinkVideo2Client);
}

// VLink视频：删除
function deleteVLinkVideo(reqData) {
    let request = {
        video_ids: reqData.videoIds
    };

    return postAndConvertResp(URLs.DELETE_VLINK_VIDEO, request, function(result) {
        return result;
    });
}

// 获取vlink攻略列表数据
export function getVlinkGuidesList(reqData) {
    let request = materialLibraryCvt.vlinkGuideList2Server(reqData);
    return queryAndConvertResp(URLs.GET_VLINK_GUIDES, request, materialLibraryCvt.vlinkGuideList2Client);
}

// 新增攻略
function addVLinkGuides(reqData) {
    let request = materialLibraryCvt.addVlinkGuide2Server(reqData, localCaches);

    return postAndConvertResp(URLs.ADD_VLINK_GUIDES, request, materialLibraryCvt.vlinkGuides2Client);
}
// vlink攻略更新
function updateVLinkGuides(reqData) {
    let request = materialLibraryCvt.updateVlinkGuide2Server(reqData);

    return postAndConvertResp(URLs.UPDATE_VLINK_GUIDES, request, materialLibraryCvt.vlinkGuides2Client);
}
// vlink攻略删除
export function deleteVLinkGuide(reqData) {
    let request = {
        tip_ids: reqData.tipIds
    };

    return postAndConvertResp(URLs.DELETE_VLINK_GUIDES, request, function(result) {
        return result;
    });
}

// 获取所有游戏渠道信息
export function getAllChannelData() {
    return queryAndConvertResp(URLs.GET_ALL_CHANNEL_DATA, {}, result => result);
}

// 素材库标签-获取多语种名称
function queryMultiLanguage(reqData) {
    let request = {
        tag_id: reqData.tagId
    };
    return queryAndConvertResp(URLs.GET_MULTI_LANGUAGE, request, materialLibraryCvt.multiLanguage2Client);
}

// 保存编辑多语种名称
function saveMultiLanguageEdit(reqData) {
    let request = materialLibraryCvt.saveMultiLanguageParams(reqData);

    return postAndConvertResp(URLs.SAVE_MULTI_LANG_EIDT, request, function(result) {
        return result;
    });
}

// 设置推荐视频，攻略
function setRecommend(reqData) {
    let request = {
        id: reqData.id,
        type: reqData.type,
        tag_id: reqData.tagId
    }

    return postAndConvertResp(URLs.SET_RECOMMEND_DATA, request, function(result) {
        return result;
    });
}

// 取消推荐视频，攻略设置
function removeRecommend(reqData) {
    let request = {
        id: reqData.id,
        type: reqData.type
    }

    return postAndConvertResp(URLs.REMOVE_RECOMMEND_DATA, request, function(result) {
        return result;
    });
}

//导出FAQ-获取导出总数
function queryExportTotal(reqData) {
    let request = {
        export_type: reqData.type,
        set_id: reqData.setId || '',
        question_ids: reqData.questionIds ? reqData.questionIds.join(",") : ''
    };
    return queryAndConvertResp(URLs.GET_EXPORT_SET_ID_TOTAL, request, result => result.standard_question_total);
}

// 添加权限
function addPermit(reqData) {
    let request = {
        permit_id: reqData.id,
        permit_name: reqData.name,
        permit_pid: reqData.parentId
    }

    return postAndConvertResp(URLs.ADD_PERMIT, request, function(result) {
        return result;
    });
}

// 删除权限
function deletePermit(reqData) {
    let request = {
        permit_id: reqData.id
    }

    return postAndConvertResp(URLs.DELETE_PERMIT, request, function(result) {
        return result;
    });
}

// 获取主推位列表
function queryResourceList(reqData) {
    let request = wikiPageCvt.resourceList2Server(reqData);
    return queryAndConvertResp(URLs.GET_REAOURCE_LIST, request, wikiPageCvt.resourceList2Client);
}

// 添加主推位
function addResource(reqData) {
    let request = wikiPageCvt.addResource2Server(reqData);
    return postAndConvertResp(URLs.ADD_REAOURCE, request, function (result) {
        return result.length > 0 ? {sectionId: result[0].section_id} : "";
    });
}

// 更新主推位
function updateResource(reqData) {
    let request = wikiPageCvt.updateResource2Server(reqData);
    return postAndConvertResp(URLs.UPDATE_REAOURCE, request, function (result) {
        return result;
    });
}

// 删除主推位
function deleteResource(reqData) {
    let request = wikiPageCvt.deleteResource2Server(reqData);
    return postAndConvertResp(URLs.DELETE_REAOURCE, request, function (result) {
        return result;
    });
}

// 移动主推位
function moveResource(reqData) {
    let request = wikiPageCvt.moveResource2Server(reqData);
    return postAndConvertResp(URLs.MOVE_REAOURCE, request, function(result) {
        return result;
    });
}

// 批量编辑修改删除资源
function batchSaveResource(reqData) {
    let request = wikiPageCvt.batchSave2Server(reqData);
    request.append('game_id', localCaches.gameId);
    return postAndConvertResp(URLs.BATCH_SAVE_REAOURCE, request, function(result) {
        return result;
    });
}

// 获取区块列表
function querySectionList(reqData) {
    let request = wikiPageCvt.sectionList2Server(reqData);
    return queryAndConvertResp(URLs.GET_SECTION_LIST, request, wikiPageCvt.sectionList2Client);
}

// 添加区块
function addSection(reqData) {
    let request = wikiPageCvt.addSection2Server(reqData);
    return postAndConvertResp(URLs.ADD_SECTION, request, wikiPageCvt.sectionData2Client);
}

// 更新区块
function updateSection(reqData) {
    let request = wikiPageCvt.updateSection2Server(reqData);
    return postAndConvertResp(URLs.UPDATE_SECTION, request, wikiPageCvt.sectionData2Client);
}


// 删除区块
function deleteSection(reqData) {
    let request = wikiPageCvt.deleteSection2Server(reqData);
    return postAndConvertResp(URLs.DELETE_SECTION, request, function(result) {
        return result;
    });
}


// 气泡问设置-获取
function getBubbleSetting(reqData) {
    let request = wikiPageCvt.bubbleSetting2Server(reqData);
    return queryAndConvertResp(URLs.GET_WIKI_CONFIG, request, wikiPageCvt.getBubbleSetting2Client);
}

// 气泡问设置-修改
function updateBubbleSetting(reqData) {
    let request = wikiPageCvt.bubbleSetting2Server(reqData);
    return postAndConvertResp(URLs.UPDATE_WIKI_CONFIG, request, function(result) {
        return result;
    });
}


// 热门搜索设置-获取
function getHotSearch(reqData) {
    let request = wikiPageCvt.hotSearch2Server(reqData);
    return queryAndConvertResp(URLs.GET_WIKI_CONFIG, request, wikiPageCvt.getHotSearch2Client);
}

// 热门搜索设置-修改
function updateHotSearch(reqData) {
    let request = wikiPageCvt.hotSearch2Server(reqData);
    return postAndConvertResp(URLs.UPDATE_WIKI_CONFIG, request, function(result) {
        return result;
    });
}

// 获取被影响的其他语种标问，提示用户
function getRelatedQuestion(reqData) {
    let request = {
        question_ids: reqData.questionId,
    };
    return queryAndConvertResp(URLs.QUES_RELATED_INFO, request, function (result) {
        return result.map(item => ({
            question: item.question,
            questionId: item.question_id,
        }));
    });
}
// 服务数据报表-累计数据概览查询
function queryCumulativeData(reqData) {
    let request = serviceDataCvt.transCumulativeData2Server(reqData);
    return queryAndConvertResp(URLs.CUMULATIVE_DATA, request, serviceDataCvt.cvtCumulativeData2Client);
}

// 服务数据报表-工单关键指标查询
function queryTiketIndicator(reqData) {
    let request = serviceDataCvt.transTiketIndicator2Server(reqData);
    return queryAndConvertResp(URLs.TICKET_INDICATOR, request, function (result){
        return serviceDataCvt.cvtTiketIndicator2Client(result, reqData);
    });
}

// 服务数据报表-数据趋势查询
function queryTiketTrend(reqData) {
    let request = serviceDataCvt.transTiketTrend2Server(reqData);
    return queryAndConvertResp(URLs.SERVICE_DATA_TREND, request, serviceDataCvt.cvtTiketTrend2Client);
}

// 服务数据报表-数据详情查询
function queryTiketDetail(reqData) {
    let request = serviceDataCvt.transTiketDetail2Server(reqData);
    return queryAndConvertResp(URLs.SERVICE_DATA_DETAIL, request, serviceDataCvt.cvtTiketDetail2Client);
}

// Ulog 获取搜索类型列表
export function getTypeListApi ({ startTime = '', endTime = ''} = {}) {
    let request = { start_time:startTime, end_time:endTime }
    return queryAndConvertResp(URLs.GET_ULOG_SEARCHYPE, request, convert.transLogSearchTypeList);
}

// Ulog 获取table数据
export function getRecordListApi (request) {
    let requestCvt = {
        start_time:request.startime,
        end_time:request.endtime,
        page:request.page,
        page_size:request.size,
        name:request.name,
        type:request.type,
        search_type:request.keywordType,
        keyword:request.keyword
    }
    return queryAndConvertResp(URLs.GET_ULOG_RECORDLIST, requestCvt, convert.transLogDataType);
}

// Ulog 获取操作人员数据
export function getOperatorListApi ({ startTime = '', endTime = ''} = {}) {
    let request = { start_time:startTime, end_time:endTime }
    return queryAndConvertResp(URLs.GET_ULOG_OPERATORS, request, function(result) {
        return result;
    });
}

// 获取赞踩设置
export function queryLikeConfig(reqData) {
    return queryAndConvertResp(URLs.GET_LIKE_CONF, {}, convert.transLikeConfig);
}

// 新增踩赞设置
export function addLikeConfig(reqData) {
    let request = convert.transLikeConfig2Server(reqData);
    return postAndConvertResp(URLs.ADD_LIKE_CONF, request, result => result);
}

// 更新赞踩设置
export function updateLikeConfig(reqData) {
    let request = convert.transLikeConfig2Server(reqData);
    return postAndConvertResp(URLs.UPDATE_LIKE_CONF, request, result => result);
}

// 新增踩赞设置
export function deleteLikeConfig(reqData) {
    return postAndConvertResp(URLs.DELETE_LIKE_CONF, reqData, result => result);
}

// 获取踩赞满意度
export function queryLikeStatistic(reqData) {
    let request = likeStatisticCvt.queryLikeStatistic2Server(reqData);
    return queryAndConvertResp(URLs.LIKE_STATISTIC_DATA_OVERVIEW, request, likeStatisticCvt.queryLikeStatistic2Client);
}

// FAQ的赞踩数据 列表
export function queryLikeQuestionList(reqData) {
    let request = likeStatisticCvt.queryLikeQuestion2Server(reqData);
    return queryAndConvertResp(URLs.LIKE_QUESTION_LIST, request, likeStatisticCvt.queryLikeQuestionList2Client);
}

// 场景的赞踩数据 列表
export function queryLikeQuestionSetList(reqData) {
    let request = likeStatisticCvt.queryLikeQuestion2Server(reqData);
    return queryAndConvertResp(URLs.LIKE_QUESTION_SET_LIST, request, likeStatisticCvt.queryLikeQuestionSet2Client);
}

// 满意度趋势图
export function querySatisfactionTrend(reqData) {
    let request = likeStatisticCvt.queryLikeStatistic2Server(reqData);
    return queryAndConvertResp(URLs.SATISFACTION_TREND, request, likeStatisticCvt.transSatisfactionTrend);
};

// 点踩原因柱形图
export function queryDislikeHistogram(reqData) {
    let request = likeStatisticCvt.queryLikeStatistic2Server(reqData);
    return queryAndConvertResp(URLs.DISLIKE_HISTOGRAM, request, likeStatisticCvt.transDislikeHistogram);
};
